// Componente que exibe a tela quando o usuário já possui um vínculo com outro profissional
// e recebeu um novo convite de vinculação
import H1 from "../../../../../components/UI/Titles/H1/h1";
import RoundedButton from "../../../../../components/Buttons/RoundedButton";
import StateView from '../shared/StateView';
import LinkMessage from '../shared/LinkMessage';
import classes from '../../RescueCode.module.scss';
import user_linking from "../../../../../assets/images/user_linking.svg";

/**
 * HasLinkView - Componente que mostra a tela de confirmação quando o usuário
 * já está vinculado a um profissional e recebe convite de outro
 * 
 * @param {Object} currentParentUser - Dados do profissional com quem o usuário já está vinculado
 * @param {Object} newParentUser - Dados do profissional que enviou o novo convite
 * @param {Function} confirmInvitation - Função chamada quando o usuário aceita o convite
 * @param {Function} rejectInvitation - Função chamada quando o usuário recusa o convite
 */
const HasLinkView = ({ 
  currentParentUser, 
  newParentUser, 
  confirmInvitation, 
  rejectInvitation 
}) => {
  return (
    // Container principal com o estilo apropriado para a tela de convite
    <StateView className={classes.inviteContainer}>
      {/* Título da tela */}
      <H1 className={classes.inviteTitle}>Novo convite recebido!</H1>

      {/* Mensagem explicativa sobre o conflito de vínculos */}
      <LinkMessage className={classes.inviteMessage}>
        {/* Informa sobre o vínculo atual */}
        <p>Atualmente, seu perfil está vinculado à <strong>{currentParentUser?.given_name || "Maria"}</strong>.</p>
        
        {/* Explica a consequência de aceitar o novo convite */}
        <p>Para aceitar o convite de <strong>{newParentUser?.given_name || "Diana"}</strong>, 
           seu vínculo com <strong>{currentParentUser?.given_name || "Maria"}</strong> será removido. 
           Você deseja continuar?</p>
      </LinkMessage>

      {/* Container para a imagem ilustrativa de vinculação de usuários */}
      <div className={classes.usersIcons}>
        <div className={classes.userIconContainer}>
          <img src={user_linking} alt="Usuários se conectando" />
        </div>
      </div>

      {/* Grupo de botões para as ações de aceitar ou recusar */}
      <div className={classes.buttonGroup}>
        {/* Botão para recusar o convite - mantém o vínculo atual */}
        <RoundedButton
          className={classes.rejectButton}
          text="RECUSAR"
          onClick={rejectInvitation}
        />
        
        {/* Botão para aceitar o convite - substitui o vínculo atual pelo novo */}
        <RoundedButton
          className={classes.acceptButton}
          text="SIM, ACEITAR CONVITE"
          onClick={confirmInvitation}
        />
      </div>
    </StateView>
  );
};

export default HasLinkView;